import { useContext, useMemo } from 'react';
import { ConfigContext } from '../../../config';
var EMAIL_SEARCH = /^(.*)@(.*?)$/;
export default (function (value) {
  var _useContext = useContext(ConfigContext),
      emailDomains = _useContext.emailDomains;

  var hints = useMemo(function () {
    if (!emailDomains) {
      return [];
    }

    var match = value === null || value === void 0 ? void 0 : value.match(EMAIL_SEARCH);

    if (match) {
      var prefix = match[1];
      var domainSearch = match[2];
      var res = domainSearch ? emailDomains.filter(function (d) {
        return d.startsWith(domainSearch);
      }) : emailDomains;
      return res.map(function (domain) {
        return "".concat(prefix, "@").concat(domain);
      });
    }

    return [];
  }, [emailDomains, value]);
  return hints;
});